"use client";

import classnames from "classnames";

import type { SidebarProps } from "./types";
import { SatelliteIcon } from "./satellite-icon";
import { SidebarAuth } from "./sidebar-auth";
import { SidebarLogo } from "./sidebar-logo";
import { SidebarNav } from "./sidebar-nav";
import styles from "./sidebar.module.scss";

export function Sidebar({
  app,
  navItems,
  navGroups,
  activeItem,
  onNavigate,
  auth,
  onSignIn,
  onSignOut,
  updateAvailable,
  onUpdate,
  footer,
  children,
  collapsedSlot,
  collapsed,
  onCollapseToggle,
  devIndicator,
  hideAuth,
}: SidebarProps) {
  return (
    <aside
      className={classnames(styles.sidebar, collapsed && styles.collapsed)}
      style={{ "--sidebar-accent": app.accentColor } as React.CSSProperties}
    >
      <SidebarLogo
        app={app}
        collapsed={collapsed}
        onCollapseToggle={onCollapseToggle}
        updateAvailable={updateAvailable}
        onUpdate={onUpdate}
      />

      <div className={styles.divider} />

      <SidebarNav
        items={navItems}
        groups={navGroups}
        activeItem={activeItem}
        onNavigate={onNavigate}
        collapsed={collapsed}
      />

      {(children || collapsedSlot) && (
        <>
          <div className={styles.divider} />
          <div className={styles.appSlot}>{collapsed ? collapsedSlot : children}</div>
        </>
      )}

      <div className={styles.spacer} />

      {footer && (
        <>
          <div className={styles.footerText}>{footer}</div>
        </>
      )}

      {devIndicator && (
        <button
          type="button"
          className={styles.devIndicator}
          onClick={() => onNavigate(devIndicator.href)}
          title="Developer settings"
          aria-label="Developer settings"
        >
          <span className={styles.devIndicatorIcon}>
            <SatelliteIcon size={16} />
            {devIndicator.active && <span className={styles.devDot} />}
          </span>
          <span className={styles.devIndicatorLabel}>Developer</span>
        </button>
      )}

      {!hideAuth && (
        <>
          <div className={styles.divider} />

          <SidebarAuth
            auth={auth}
            collapsed={collapsed}
            onSignIn={onSignIn}
            onSignOut={onSignOut}
            onCollapseToggle={onCollapseToggle}
          />
        </>
      )}
    </aside>
  );
}
